// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"g_G container-lg d-flex p-3","doc-page":"g_H","doc-page__title--enterprise":"g_J","doc-page--with-side-menu":"g_K","doc-page__title":"g_L"};